<page-header [section]="'device-type-mapping'">
  <page-title>Device Type Mapping</page-title>
  <page-blurb
    >View device types entries and manage device type mapping entries by
    creating new range mapping entries depending on mapping series / batch, or
    edit existing mapping entries.</page-blurb
  >
</page-header>

<spinner *ngIf="!entries"></spinner>

<div *ngIf="entries">
  <div class="row mb-3" *ngIf="series.length">
    <div class="col-12 col-md-6 mx-auto">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text"><i class="fa fa-search"></i></span>
        </div>
        <input
          type="text"
          class="form-control"
          placeholder="Search by hex value (e.g. 0BD010)"
          [(ngModel)]="searchHex"
        />
        <div class="input-group-append" *ngIf="searchHex">
          <button class="btn btn-outline-secondary" type="button" (click)="searchHex = ''">
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>
      <small class="form-text text-muted mt-1">
        Enter a hex value to show only entries whose range contains that value.
      </small>
    </div>
  </div>

  <div class="row" *ngIf="searchHex && filteredSeriesList.length === 0">
    <div class="col">
      <div class="alert alert-info">No entries found for hex value <strong>{{ searchHex }}</strong>.</div>
    </div>
  </div>

  <div class="row" *ngFor="let s of (searchHex ? filteredSeriesList : series)">
    <div class="col">
      <div class="card">
        <div class="card-header bg-primary">
          <span class="display-4">Device Type Mapping: Series [{{ s }}]</span>
        </div>
        <div class="card-body m-2">
          <div class="row" *ngFor="let b of (searchHex ? filteredBatchesList(s) : batches[s])">
            <div class="col">
              <div class="card">
                <div class="card-header bg-success">
                  <span class="display-5"
                    >Device Type Mapping: Series [{{ s }}]: Batch [{{
                      b
                    }}]</span
                  >

                  <div class="card-header-actions">
                    <span class=""
                      ><i
                        (click)="add($event, newMapModal, s, b)"
                        class="text-black-50 fa fa-lg fa-plus"
                      ></i
                    ></span>
                  </div>
                </div>
                <div class="card-body m-1">
                  <div class="row mb-4" *ngIf="!searchHex">
                    <div class="col text-center">
                      <button
                        class="btn btn-primary"
                        (click)="add($event, newMapModal, s, b)"
                        type="button"
                      >
                        <i class="pr-2 fa fa-lg fa-plus"></i>&nbsp;Add Mapping
                      </button>
                    </div>
                  </div>

                  <device-range-widget
                    *ngFor="let entry of filteredEntriesList(s, b); let i = index"
                    (widgetEvent)="eventHandler($event, newMapModal)"
                    [entity]="entry"
                    [layout]="'table'"
                    [options]="{ batch: b, series: s, index: i }"
                  ></device-range-widget>
                </div>
                <div class="card-footer">
                  <div class="row">
                    <div class="col text-center">
                      <button
                        class="btn btn-primary"
                        (click)="add($event, newMapModal, s, b)"
                        type="button"
                      >
                        <i class="pr-2 fa fa-lg fa-plus"></i>&nbsp;Add Mapping
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--                                                        -->
<!--                    Pop-Up Menu                         -->
<!--                                                        -->
<ng-template #newMapModal>
  <modal-widget
    [entity]="currentModal"
    [layout]="'shadow_box'"
    [options]="{}"
  ></modal-widget>
</ng-template>

<!--                                                        -->
<!--                  Warning Confirmation                  -->
<!--                                                        -->
<ng-template #warningModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Warning</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="cancelWarningAction()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Make sure this operation is not performed during US daytime, as it may cause issues on the server side, especially when processing a large range.</p>
    <p>Do you want to continue?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancelWarningAction()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="confirmWarningAction()">Continue</button>
  </div>
</ng-template>
